__turbopack_context__.v({
  "backdrop": "dialog-module__fFTgOq__backdrop",
  "body": "dialog-module__fFTgOq__body",
  "bodyNoHeader": "dialog-module__fFTgOq__bodyNoHeader",
  "closeBtn": "dialog-module__fFTgOq__closeBtn",
  "dialog": "dialog-module__fFTgOq__dialog",
  "fadeIn": "dialog-module__fFTgOq__fadeIn",
  "footer": "dialog-module__fFTgOq__footer",
  "header": "dialog-module__fFTgOq__header",
  "pop": "dialog-module__fFTgOq__pop",
  "shimmer": "dialog-module__fFTgOq__shimmer",
  "skeletonImg": "dialog-module__fFTgOq__skeletonImg",
  "skeletonLine": "dialog-module__fFTgOq__skeletonLine",
  "skeletonLineMedium": "dialog-module__fFTgOq__skeletonLineMedium",
  "skeletonLineShort": "dialog-module__fFTgOq__skeletonLineShort",
  "skeletonLineWide": "dialog-module__fFTgOq__skeletonLineWide",
  "skeletonWrap": "dialog-module__fFTgOq__skeletonWrap",
  "subtitle": "dialog-module__fFTgOq__subtitle",
  "title": "dialog-module__fFTgOq__title",
  "titleGroup": "dialog-module__fFTgOq__titleGroup",
  "toolbar": "dialog-module__fFTgOq__toolbar",
});
